
const contribute = {
  path: 'contribute',
  component: resolve => require(['../../../../../pages/modules/knowledge/contribute'], resolve),
}

export default contribute
